/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { OrganizationType } from './OrganizationType'
import {
  OrganizationTypeFromJSON,
  OrganizationTypeFromJSONTyped,
  OrganizationTypeToJSON,
} from './OrganizationType'
import type { ApplicantData } from './ApplicantData'
import {
  ApplicantDataFromJSON,
  ApplicantDataFromJSONTyped,
  ApplicantDataToJSON,
} from './ApplicantData'

/**
 *
 * @export
 * @interface Applicant
 */
export interface Applicant {
  /**
   *
   * @type {OrganizationType}
   * @memberof Applicant
   */
  type: OrganizationType
  /**
   *
   * @type {ApplicantData}
   * @memberof Applicant
   */
  data: ApplicantData
}

/**
 * Check if a given object implements the Applicant interface.
 */
export function instanceOfApplicant(value: object): value is Applicant {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function ApplicantFromJSON(json: any): Applicant {
  return ApplicantFromJSONTyped(json, false)
}

export function ApplicantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Applicant {
  if (json == null) {
    return json
  }
  return {
    type: OrganizationTypeFromJSON(json['type']),
    data: ApplicantDataFromJSON(json['data']),
  }
}

export function ApplicantToJSON(value?: Applicant | null): any {
  if (value == null) {
    return value
  }
  return {
    type: OrganizationTypeToJSON(value['type']),
    data: ApplicantDataToJSON(value['data']),
  }
}
